import React, { FC } from "react";

const VerifyEmail: FC = (props) => {
  return <div></div>;
};

export default VerifyEmail;
